<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<div class="pb-2" [class.detract-attention]="!quote" [formGroup]="form" data-zid="quantity-container">
  <div class="left" [class.left]="mode === 'value'">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <div class="nav-tabs mb-1 mt-0 no-select">
        <div class="nav-item mr-sm-2">
          <a
            class="nav-link text-nowrap font-medium"
            data-zid="mode-quantity"
            [class.active]="mode === 'quantity'"
            (click)="toggleMode('quantity')"
          >
            {{ 'trade.create.quantity.quantity.label' | transloco }}
          </a>
        </div>
        <div class="nav-item ml-1">
          <a class="nav-link text-nowrap font-medium" data-zid="mode-value" [class.active]="mode === 'value'" (click)="toggleMode('value')">
            {{ 'trade.create.quantity.value.label' | transloco }}
          </a>
        </div>
      </div>
      @if (displayValidity) {
        <div class="text-size-large text-right text-nowrap no-select">
          {{ 'trade.create.quantity.validTo' | transloco }}
          @if (quote) {
            <input
              formControlName="validToDate"
              size="9"
              #dateInput
              #d="ngbDatepicker"
              id="validToDate"
              ngbDatepicker
              placement="top-right"
              [class.empty]="!form.get('validToDate').value"
              [markDisabled]="isDateDisabled()"
              [minDate]="minDate"
              [maxDate]="maxDate"
              (focus)="openDatepicker($event, d, dateInput)"
            />
          } @else {
            <span>&mdash;</span>
          }
        </div>
      }
    </div>
  </div>
  <div class="d-flex justify-content-between align-items-center">
    <div class="input-group-material" [class.left]="mode === 'value'" [class.input-group-material--error]="value && quantity?.errors">
      @if (mode === 'value') {
        <input
          type="text"
          inputmode="numeric"
          [ngModel]="displayValue"
          [ngModelOptions]="{ standalone: true }"
          [disabled]="!quote"
          [placeholder]="'trade.create.quantity.value.placeholder' | transloco"
          zeroCurrencyInput
          (paste)="handleValuePaste($event)"
          (ngModelChange)="handleValueChange($event)"
          data-zid="number-input"
        />
      }
      @if (mode === 'quantity') {
        <input
          type="number"
          formControlName="quantity"
          [disabled]="!quote"
          [placeholder]="'trade.create.quantity.quantity.placeholder' | transloco"
          (wheel)="handleWheel($event)"
          (paste)="handleQuantityPaste($event)"
          data-zid="number-input"
        />
      }
    </div>
    @if (mode === 'value') {
      <div class="ml-2">
        {{ 'trade.create.quantity.is-equivalent-to' | transloco }}
        @if (quantity.value) {
          {{ quantity.value | number: '1.0-' + (asset?.qtyScale ? asset.qtyScale : 3) }}
        } @else {
          <span>&mdash;</span>
        }
        {{ 'trade.create.quantity.pc' | transloco }}
      </div>
    }
  </div>
  @if (quantity.hasError('quantityInvalid')) {
    <div class="mt-2 text-size-small text-color-error" data-zid="error-quantity">
      {{ quantity.getError('quantityInvalid')[mode] | transloco }}
    </div>
  }
  @if (quantity.hasError('fragments')) {
    <div class="mt-2 text-size-small text-color-error" data-zid="error-fragments">
      {{ quantity.getError('fragments') | transloco }}
    </div>
  }
  @if (quantity.hasError('maximumFraction')) {
    <div class="mt-2 text-size-small text-color-error" data-zid="error-fragments">
      {{ quantity.getError('maximumFraction').key | transloco: { digits: quantity.getError('maximumFraction').digits } }}
    </div>
  }
  @if (quantity.hasError('minOrderValue') || (quantity.hasError('zero') && mode === 'value')) {
    <div class="mt-2 text-size-small text-color-error" data-zid="error-minOrderValue">
      @if (quantity.hasError('minOrderValue')) {
        {{
          'trade.create.quantity.errors.min-order-value.' + mode
            | transloco
              : {
                  minimumQuantity: mode === 'quantity' ? null : (quantity.getError('minOrderValue').minimumQuantity | number: '1.0-3'),
                }
        }}
      } @else {
        {{
          'trade.create.quantity.errors.min-order-value.value'
            | transloco
              : {
                  minimumQuantity: quantity.getError('zero').minimumQuantity | number: '1.0-3',
                }
        }}
      }
    </div>
  }
  @if (quantity.hasError('orderValueTooLow')) {
    <div class="mt-2 text-size-small text-color-error" data-zid="error-value-to-low">
      {{
        quantity.getError('orderValueTooLow').key + '.text'
          | transloco
            : {
                minimumOrderValueForAsset: quantity.getError('orderValueTooLow').minimumOrderValueForAsset | currency: 'EUR' : 'symbol',
              }
      }}
      <a
        (click)="setMinimumQuantity(quantity.getError('orderValueTooLow').minimumQuantity)"
        class="text-color-error text-underline cursor-pointer"
      >
        {{
          quantity.getError('orderValueTooLow').key + '.link'
            | transloco
              : {
                  minimumQuantity: quantity.getError('orderValueTooLow').minimumQuantity,
                }
        }}
      </a>
    </div>
  }
  @if (quantity.hasError('minQty')) {
    <div class="mt-2 text-size-small text-color-error">
      {{
        quantity.getError('minQty').key
          | transloco
            : {
                qtyScale: quantity.getError('minQty').minQty | number: '1.0-' + quantity.getError('minQty').qtyScale,
              }
      }}
    </div>
  }
  @if (shouldDisplayHighVolumeWarning) {
    <ng-container *ngTemplateOutlet="highVolumeWarning" />
  }
  @if (direction === 'sell' && positionInSelectedAsset) {
    <ng-container *ngTemplateOutlet="availableQuantityHint" />
  }
  <hr class="mt-4" />
</div>

<ng-template #highVolumeWarning>
  <div class="mt-2 zero-text p-small-reg warning">
    {{ 'trade.create.quantity.high-volume-hint.label' | transloco }}
    <div class="icon-tooltip-wrapper">
      <web-design-system-icon
        name="error"
        size="small"
        class="cursor-pointer"
        (click)="isHighVolumeTooltipVisible = !isHighVolumeTooltipVisible"
      />
      @if (isHighVolumeTooltipVisible) {
        <div class="icon-tooltip-content text-left icon-tooltip-content--show autoheight">
          <web-design-system-icon
            name="clear"
            size="small"
            class="icon-tooltip-close"
            (click)="isHighVolumeTooltipVisible = !isHighVolumeTooltipVisible"
          />
          <div
            [innerHTML]="
              'trade.create.quantity.high-volume-hint.tooltip' | transloco: { value: direction === 'buy' ? quote.askv : quote.bidv }
            "
          ></div>
        </div>
      }
    </div>
  </div>
</ng-template>

<ng-template #availableQuantityHint>
  <div
    class="mt-2 text-size-small"
    [class.text-color-error]="
      quantity.hasError('orderValueTooLow') || quantity.hasError('quantityInvalid') || quantity.hasError('notEnoughQuantity')
    "
  >
    @if (quantity?.value > 0) {
      {{
        'trade.create.quantity.available-quantity-hint.has-quantity'
          | transloco
            : {
                quantity: quantity.value | number: '1.0-8',
                available: positionInSelectedAsset.availableQuantity | number: '1.0-8',
              }
      }}
    }
    @if (!(quantity.value > 0)) {
      <a class="zero-text link" (click)="useQty(positionInSelectedAsset.availableQuantity)">
        {{
          'trade.create.quantity.available-quantity-hint.default'
            | transloco
              : {
                  available: positionInSelectedAsset.availableQuantity | number: '1.0-8',
                }
        }}
      </a>
    }
    <div class="icon-tooltip-wrapper">
      <svg class="icon icon-14 cursor-pointer" (click)="isAvailableQuantityTooltipVisible = !isAvailableQuantityTooltipVisible">
        <use xlink:href="/assets/img/svgs/svgset.svg#info" />
      </svg>
      @if (isAvailableQuantityTooltipVisible) {
        <div class="icon-tooltip-content text-left icon-tooltip-content--show">
          <div class="icon-tooltip-close" (click)="isAvailableQuantityTooltipVisible = !isAvailableQuantityTooltipVisible">
            <svg class="icon icon-14">
              <use xlink:href="/assets/img/svgs/svgset.svg#close" />
            </svg>
          </div>
          <div class="d-flex">
            <div class="flex-grow">{{ 'trade.create.quantity.available-quantity-hint.tooltip.quantity' | transloco }}</div>
            <div>
              {{ positionInSelectedAsset.quantity | number: '1.0-8' }}
            </div>
          </div>
          <div class="d-flex border-bottom">
            <div class="flex-grow">{{ 'trade.create.quantity.available-quantity-hint.tooltip.open-orders' | transloco }}</div>
            <div>
              {{ positionInSelectedAsset.quantity - positionInSelectedAsset.availableQuantity | number: '1.0-8' }}
            </div>
          </div>
          <div class="d-flex">
            <div class="flex-grow">{{ 'trade.create.quantity.available-quantity-hint.tooltip.available' | transloco }}</div>
            <div>
              {{ positionInSelectedAsset.availableQuantity | number: '1.0-8' }}
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</ng-template>
